var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "560E157F-D5DD-4B2D-BB85-4B45C2963AF9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.X.4-Blueprints---Components---New-Component---Second-Name-Field",
    transform: "translate(-718.000000, -278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(708.000000, 266.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0638298,0 L0.907801418,0 C0.406436539,0 0,0.406436539 0,0.907801418 L0,15.4326241 C0,15.933989 0.406436539,16.3404255 0.907801418,16.3404255 L19.0638298,16.3404255 C19.5651947,16.3404255 19.9716312,15.933989 19.9716312,15.4326241 L19.9716312,0.907801418 C19.9716312,0.406436539 19.5651947,0 19.0638298,0 Z M16.8723972,1.81560284 L9.9858156,8.7021844 L3.09923404,1.81560284 L16.8723972,1.81560284 Z M1.81560284,14.5248227 L1.81560284,3.09923404 L9.344,10.6276312 C9.69849632,10.9820205 10.2731349,10.9820205 10.6276312,10.6276312 L18.1560284,3.09923404 L18.1560284,14.5248227 L1.81560284,14.5248227 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emailIcon.939b3f1ebe7648296a987d56861a95b3.svg";